<form [formGroup]="formGroup" style="padding-top: 2%;">
  <ion-segment [formControlName]="controlName">
    @for (button of buttons; track button) {
      <ion-segment-button [value]="button.value" (click)="button.callback" [ngStyle]="button.style">
        <ion-label style="color: var(--ion-color-text)">{{ button.name }}</ion-label>
        @if (button.icon) {
          <ion-icon style="width:40px;" [name]="button.icon.name || 'power-outline'"
            [color]="formGroup.controls[controlName].value === button.value ? button.icon.color : 'normal'"
            [size]="button.icon.size || 'medium'">
          </ion-icon>
        }
      </ion-segment-button>
    }
  </ion-segment>
</form>
